<template>
  <div>
    <h1>Медиаплан</h1>
    <div class="row">
      <div class="col-md-4">
        <c-box>
          <h4>Мониторинг</h4>
          <li>Настройка - корректировка сервиса</li>
          <li>Мониторинг и анализ данных</li>
        </c-box>
      </div>
      <div class="col-md-4">
        <c-box>
          <h4>SERM - стратегия</h4>
          <li>Сбор актуальной стратегии по запросам в ТОП 20</li>
          <li>Подготовка актуального медиаплана и его корректировка</li>
        </c-box>
      </div>
      <div class="col-md-4">
        <c-box>
          <h4>Работа с отзывами</h4>
          <li>Подготовка контента</li>
          <li>Топ</li>
          <li>Лидеры мнений</li>
          <li>Справочники</li>
        </c-box>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <c-box>
          <h4>Работа с ресурсами топ</h4>
          <li>Регистрация карточек компании</li>
          <li>Восстановление доступов</li>
          <li>Актуализация данных</li>
          <li>Подтверждение официального представителя</li>
          <li>Размещение претензий на удаление отзывов</li>
        </c-box>
      </div>
      <div class="col-md-4">
        <c-box>
          <h4>ORM - стратегия</h4>
          <li>Политика коммуникации</li>
          <li>Коммуникация</li>
          <li> Коммуникация от лица бренда</li>
          <li>Коммуникация от лица агентов влияния</li>
        </c-box>
      </div>
    </div>
    <button
      class="btn background-white border-danger text-danger"
      type="button"
    >
      Скачать коммерческое предложение
    </button>
  </div>
</template>

<script>
import CBox from '../../../../../../resources/js/components/ui/CBox'

export default {
  name: 'Mediaplan.vue',
  components: { CBox },

  data: () => ({
    isLoading: false
  })
}
</script>
